'use client';

import { c as _c } from "react/compiler-runtime";
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { CalendarWrapper } from '@algoacademy/design-system/web/forms/Calendar';
import { H2, H3 } from '@algoacademy/design-system/web/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { format } from 'date-fns';
import { useMemo, useState } from 'react';
import type { CalendarEvent } from '../../_components/CalendarEvent';
import { useGenerateEventsSlotsForSelectedDay } from '../UpdateOrganizerAvailability/_hooks/useGenerateEventsSlotsForSelectedDay';
import { useLoadOrganizerAvailability } from '../UpdateOrganizerAvailability/_hooks/useLoadOrganizerAvailability';
import { EventList } from './_components/EventList';
import { FixedAvailability } from './_components/FixedAvailability';
import { WEEK_DAYS } from './_components/HourSelector';
import { SaveButton } from './_components/SaveButton';
import { useAvailableDays } from './_hooks/useAvailableDays';
import { useMergedSelectedEvents } from './_hooks/useMergedSelectedEvents';
import { useOrganizerAvailability } from './_hooks/useOrganizerAvailability';

// todo: loading skeleton
// todo: logika odznaczania z fixed jak wszystkie recurring są excluded
// todo: ogólny refactor plików zeby byly ladniejsze
type SelectedEventsByWeekDay = Record<WEEK_DAYS, string[]>;
export function UpdateOrganizerAvailabilitySection() {
  const $ = _c(56);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Map();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [eventsForSelectedDay, setEventsForSelectedDay] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Map();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [selectedEventsMap, setSelectedEventsMap] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Date();
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [selectedDay, setSelectedDay] = useState(t2);
  const [selectedHoursByDay, setSelectedHoursByDay] = useState(_temp);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = new Set();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [excludedRecurringEvents, setExcludedRecurringEvents] = useState(t3);
  const {
    queries,
    combinedData
  } = useOrganizerAvailability(selectedDay);
  let set;
  if ($[4] !== combinedData.events) {
    set = new Set();
    for (const event of combinedData.events) {
      if (event.isBooked) {
        set.add(format(event.startTime, "yyyy-MM-dd'T'HH:mm"));
      }
    }
    $[4] = combinedData.events;
    $[5] = set;
  } else {
    set = $[5];
  }
  const bookedEventIdsSet = set;
  let t4;
  if ($[6] !== bookedEventIdsSet || $[7] !== selectedDay) {
    t4 = {
      forDay: selectedDay,
      setEventsForSelectedDay,
      bookedEventIdsSet
    };
    $[6] = bookedEventIdsSet;
    $[7] = selectedDay;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useGenerateEventsSlotsForSelectedDay(t4);
  let t5;
  if ($[9] !== combinedData) {
    t5 = {
      organizerAvailabilityData: combinedData,
      setSelectedHoursByDay,
      setSelectedEventsMap
    };
    $[9] = combinedData;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  useLoadOrganizerAvailability(t5);
  let t6;
  if ($[11] !== excludedRecurringEvents || $[12] !== selectedEventsMap || $[13] !== selectedHoursByDay) {
    t6 = {
      selectedEventsMap,
      selectedHoursByDay,
      excludedRecurringEvents
    };
    $[11] = excludedRecurringEvents;
    $[12] = selectedEventsMap;
    $[13] = selectedHoursByDay;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const mergedSelectedEventsMap = useMergedSelectedEvents(t6);
  let t7;
  if ($[15] !== excludedRecurringEvents || $[16] !== selectedEventsMap || $[17] !== selectedHoursByDay) {
    t7 = {
      selectedEventsMap,
      selectedHoursByDay,
      excludedRecurringEvents
    };
    $[15] = excludedRecurringEvents;
    $[16] = selectedEventsMap;
    $[17] = selectedHoursByDay;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const availableDays = useAvailableDays(t7);
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <H2>Podaj swoją dyspozycyjność na czas konsultacji.</H2>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== selectedHoursByDay) {
    t9 = <FixedAvailability selectedHoursByDay={selectedHoursByDay} setSelectedHoursByDay={setSelectedHoursByDay} />;
    $[20] = selectedHoursByDay;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <H3>Twój kalendarz</H3>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== availableDays || $[24] !== selectedDay) {
    t11 = <div className="space-y-6">{t10}<CalendarWrapper className="w-fit" mode="single" selected={selectedDay} onSelect={setSelectedDay} availableDays={availableDays} required={true} /></div>;
    $[23] = availableDays;
    $[24] = selectedDay;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== selectedDay) {
    t12 = format(selectedDay, "dd.MM.yyyy");
    $[26] = selectedDay;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = <H3>Wybrane terminy {t12}</H3>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <P2 className="text-contentSecondary">Niezależne od twoich stałych godzin konsultacji.</P2>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13) {
    t15 = <header className="space-y-2">{t13}{t14}</header>;
    $[31] = t13;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== eventsForSelectedDay || $[34] !== excludedRecurringEvents || $[35] !== mergedSelectedEventsMap || $[36] !== selectedDay || $[37] !== selectedHoursByDay) {
    t16 = <EventList eventsForSelectedDay={eventsForSelectedDay} selectedEventsMap={mergedSelectedEventsMap} setSelectedEventsMap={setSelectedEventsMap} selectedDay={selectedDay} selectedHoursByDay={selectedHoursByDay} excludedRecurringEvents={excludedRecurringEvents} setExcludedRecurringEvents={setExcludedRecurringEvents} />;
    $[33] = eventsForSelectedDay;
    $[34] = excludedRecurringEvents;
    $[35] = mergedSelectedEventsMap;
    $[36] = selectedDay;
    $[37] = selectedHoursByDay;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t15 || $[40] !== t16) {
    t17 = <LightCard className="w-full space-y-6 rounded-lg">{t15}{t16}</LightCard>;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t11 || $[43] !== t17) {
    t18 = <section className="flex flex-col items-center gap-4 lg:flex-row lg:items-start">{t11}{t17}</section>;
    $[42] = t11;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t18 || $[46] !== t9) {
    t19 = <div className="space-y-12">{t9}{t18}</div>;
    $[45] = t18;
    $[46] = t9;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== queries) {
    t20 = queries.map(_temp2);
    $[48] = queries;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== mergedSelectedEventsMap || $[51] !== t20) {
    t21 = <SaveButton selectedEventsMap={mergedSelectedEventsMap} refetchQueries={t20} />;
    $[50] = mergedSelectedEventsMap;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t19 || $[54] !== t21) {
    t22 = <main className="flex flex-col gap-4">{t8}{t19}{t21}</main>;
    $[53] = t19;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  return t22;
}
function _temp2(q) {
  return q.refetch;
}
function _temp() {
  return {
    [WEEK_DAYS.MONDAY]: [],
    [WEEK_DAYS.TUESDAY]: [],
    [WEEK_DAYS.WEDNESDAY]: [],
    [WEEK_DAYS.THURSDAY]: [],
    [WEEK_DAYS.FRIDAY]: [],
    [WEEK_DAYS.SATURDAY]: [],
    [WEEK_DAYS.SUNDAY]: []
  };
}